import { IconExpandDown, Navigation } from '@by-miles/bymiles-styles'
import React, { useState } from 'react'

import { BenefitsWrapper } from './BenefitsWrapper'
import { CoverBenefitStyles } from './CoverBenefitStyles'

export const CoverBenefits = ({ benefitsOverview, customerBenefits, carBenefits, isElectric, className }) => {
  const [open, setOpen] = useState(false)

  return (
    <CoverBenefitStyles className={`${className} ${open ? 'open' : ''}`} open={open}>
      <div className="inner-container">
        <div className="inner-wrapper">
          <BenefitsWrapper heading="overview" items={benefitsOverview} isElectric={isElectric} />

          <BenefitsWrapper heading="For you" items={customerBenefits} isElectric={isElectric} />
        </div>
        <div className="divider-wrapper">
          <BenefitsWrapper heading="For your car" items={carBenefits} isElectric={isElectric} />
        </div>
        <div className="shadow" />
      </div>
      <div className="show-all" onClick={() => setOpen(!open)}>
        <div className="see-all-text">
          <Navigation className="text">See all 13</Navigation>
          <IconExpandDown />
        </div>
      </div>
    </CoverBenefitStyles>
  )
}
